import { NgModule } from '@angular/core';
import { defaultSettings, PORTAL_SETTINGS } from '.';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    {
      provide: PORTAL_SETTINGS,
      useValue: defaultSettings
    }
  ]
})
export class SettingsModule {
}
